export const GAP = {
    xs: 6,
    sm: 8,
    md: 8,
    lg: 8,
    xl: 8,
};
export const HEIGHT = {
    xs: 24,
    sm: 32,
    md: 40,
    lg: 48,
    xl: 56,
};
export const PADDING = {
    BLOCK: { xs: 4, sm: 4, md: 4, lg: 4, xl: 4 },
    INLINE: { xs: 12, sm: 14, md: 16, lg: 20, xl: 24 },
};
